module.exports = {
  message: {
    title: "Sport Brands",
  },
  placeholder: {
    enter: "Please type in your favorite brand",
  },
  brands: {
    nike: "Nike",
    adi: "Adidas",
    nb: "New Banlance",
    ln: "LI Ning",
  },
  menue: {
    detail: "SocialDetails",
    find: "Find",
    porj: "PresetProject",
    custom: "CustomManagement",
    customized: "Customized collection",
  },
  topHead: {
    select_option_category: "Category",
    select_option_category_holder:
      "You can enter Title keywords or product links to search",
    select_option_brand: "Brand",
    select_option_phone: "Phone number",
    select_option_work_order: "Work order number",
    select_option_brand_holder: "Please select",
    select_option_postKeyWords: "PostKeywords",
    select_option_postKeyWords_holder: "Please enter the content",
    rules_message_search: "Enter at least one brand or post content",
    my_attention: "MyAttention",
    login_label: "SignIn",
    login_out: "SignOut",
    Chinese: "中文",
    English: "English",
  },
  mainHead: {
    eidtTooltip: "Edit search criteria",
    platList_weibo: "Micro Blog",
    platList_douyin: "Tik Tok",
    platList_xhs: "Red Booklet",
    dateLabel: "Date",
    date_to: "To",
    date_holder: "Select month",
    saveProj: "Save scheme",
    tabs_baseInfo: "BaseInfo",
    tabs_crowdPortrait: "Crowd portrait",
    tabs_talents: "Talent list",
    tabs_brand: "Brand list",
    tabs_custom: "Custom analysis",
    rules_message_search:
      "Enter at least one brand or category or post content",
    rules_message_search2:
      "At least one of the brand or category or post content is not empty",
    rules_message_range: "Time range cannot be empty",
    message_saveProj_success: "Scheme saved successfully",
    message_saveProj_failed: "Failed to save scheme",
  },
  search: {
    title: "Add search criteria",
    form_postWord: "PostKeywords",
    form_postWord_tip:
      "Support and, or, not logic, and word segmentation are separated by spaces; For example: lipstick and (Lip Glaze or lip gloss) not matte",
    form_brand: "Brand",
    form_brand_holder: "Enter brand keywords",
    form_brand_tip:
      "For example, searching for the brand 'apple / Apple' will filter out the posts containing 'Apple' or 'Apple' or 'apple / Apple', and the posts representing 'apple / Apple' can be determined through semantic analysis.",
    form_category: "Category",
    form_cat_tip:
      "Please select the category you want to view. Currently, only leaf categories are supported",
    form_plat: "Platform",
    form_platOption_douyin: "Tik Tok",
    form_platOption_weibo: "Micro Blog",
    form_platOption_xhs: "Red Booklet",
    form_dateRange: "TimeRange",
    form_dateRange_holder: "Select month",
    form_dateRange_to: "To",
    searchBtnLab: "Search",
    operation: "Operation",
  },
  baseInfo: {
    trend: "trend",
    posts: "Post",
    posts_toolTip: "Number of All Posts",
    interaction: "Interaction",
    interaction_toolTip: "Comments + Likes + Forwards",
    platTitle: "Platform distribution",
    cloudWordTitle: "WordCloud",
    TalentTitle: "Top 10 list of talents",
    PostListLabel: "Volume ranking",
    IteractionListLabel: "Interaction ranking",
    BrandTitle: "Brand top 10 list",
    postContent: "Original post",
    postType_all: "Overall",
    postType_Forward: "Positive",
    postType_back: "Negative",
    postType_neutral: "Neutral",
    selectedCondition: "Selected Conditions",
    postKeyWordLabel: "Post Keywords:",
    cloudWordLabel: "CloudWord:",
    kolLabel: "KOL:",
    catLabel: "Category：",
    brandLabel: "Brand:",
    brand: "Brand",
    originPostLink: "Posts Link",
    workOrder: "Work Order",
    negativePostPercent: "Proportion of negative posts",
    reposts: "Forwarding",
    comments: "Comments",
    zans: "Likes",
    participle: "Participle",
    frequency: "Frequency",
    photo: "Photo",
    Talent: "Talent",
    plant: "platform",
    fansNum: "FansNum",
    downLoad: "DownLoad",
    downLoading: "DownLoading...",
    ranking: "Ranking",
    cloud_nameLabel: "word",
    cloud_valueLabel: "count",
    gender: "gender",
    age: "age",
    region: "region",
    cityLevel: "cityLevel",
    interest: "interest",
    interestStatistics: "interest word cloud and word frequency count",
    distribution: "distribution",
    concerned: "concerned",
    category: "category",
    user: "Users",
    tgi: "TGI",
    man: "man",
    woman: "woman",
  },
  TalentList: {
    allPosts: "All Posts",
    forwardPosts: "Positive Posts",
    backPosts: "Negative Posts",
    neutralPosts: "Neutral Posts",
  },
  proj: {
    title: "Preset Project",
    userDefinedName: "Custom name",
    postsKeyWords: "Post keyword",
    brand: "Brand",
    cat: "Category",
    Talent: "Talent",
    plant: "platform",
    date: "Date",
    to: " To ",
  },
  footer: {
    content_one:
      "All data of E-commerce Magic Mirror come from public pages. E-commerce Magic Mirror has no direct connection with Taobao, Tmall, JINGdong,  Amazon and other e-commerce platforms, and is an independent third-party e-commerce data agency  ",
      content_two:
      "Beijing Taomi Technology Limited Co., LTD. ",
    content_icp: "Beijing ICP 15061734-4 ",
    content_goan: "Beijing network security 11010502037832 ",
    content_add:
      "Data is collected and summarized by the public page, the data caliber is different from that of the platform and other organizations, and it is for reference only. If there is any difference, please refer to the official data released by the platform.",
  },
  keywords: "keyword:",
  customer: "customer_speak:",
  seller: "seller_speak:",
  company: "customer/company:",
  issue: "work order number:",
  phone: "phone number:",
};
